import {inject, injectable} from 'inversify';

import {logger} from '../../../utils/logger';
import {FetchCardsListQuery} from '../../ports/Card/FetchCardsList/FetchCardsList.query';

@injectable()
export class FetchCurrentUserCardsListUseCase {
  constructor(
    @inject(FetchCardsListQuery)
    private readonly fetchCardsList: FetchCardsListQuery,
  ) {}

  async exec(): Promise<FetchCurrentUserCardsListUseCase.Response> {
    try {
      return this.fetchCardsList.exec();
    } catch (e) {
      logger.error(e);

      throw e;
    }
  }
}

export namespace FetchCurrentUserCardsListUseCase {
  export type Props = unknown;
  export type Response = FetchCardsListQuery.Response;
}
